// extracted by mini-css-extract-plugin
export default {"loaderIcon":"Loader_loaderIcon__aW0Uh","spin":"Loader_spin__1eUNQ"};